<template>
  <main>
    <slot></slot>
  </main>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "MainContainer",
  props: {},
})
</script>
<style scoped lang="scss">
main {
  min-height: calc(var(--vh) * 100 - var(--header-height) - 32px);
  min-width: 500px;
  // margin: 32px 40px 0 0;
  margin-left: calc(var(--left-aside-width) + 32px);
  margin-right: calc(var(--chat-width) + 32px);
  margin-top: calc(var(--header-height) + 32px);
  padding-bottom: 100px;
  box-sizing: border-box;
}
</style>
